import React from 'react';
import MainContainer from './components/MainContainer';

import 'antd/dist/antd.css';

const App = (): JSX.Element => (
  <MainContainer />
);

export default App;
